import { API } from "./axiosInstance";

export const getKeycloakUsernamesByUUID = async (uuids) => {
    const usernames = await API.get(`/keycloakUsername`, {params: {uuids: uuids}});
    return usernames.data;
}